import { render } from "./PrintIncomeComponent.vue?vue&type=template&id=837a7694"
import script from "./PrintIncomeComponent.vue?vue&type=script&lang=js"
export * from "./PrintIncomeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__